import styled from 'styled-components';

export const UploadFilesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 1.5rem;

  label {
    font-size: 14px;
    color: var(--gray);
    margin-bottom: 8px;
  }
`;

export const DropzoneContainer = styled.div`
  width: 100%;
`;

export const File = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  padding: 10px 15px;
  margin-top: 1rem;

  background-color: #f0eaf8;
  border: 1px solid #dcd0e5;
  border-radius: 8px;

  span {
    font-size: 14px;
    color: #333;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 1rem;
  }

  svg {
    cursor: pointer;
    color: var(--fixit-danger, #e53e3e);
    transition: color 0.2s ease-in-out;
    flex-shrink: 0;

    &:hover {
      color: #c53030;
    }
  }
`;
